import Navbar from "../components/Navbar";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import FormContainer from "../components/FormContainer";
import "../components/Map.css";
import { IoArrowBackOutline } from "react-icons/io5";
import { Button, Col, Form, Row } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
const URL =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:3001";
function Reports() {
  const [genSetNumber, setGenSetNumber] = useState(0);
  const [startDate, setStartDate] = useState(new Date().toISOString()?.split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString()?.split('T')[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const productList = useSelector((state) => state.productList);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const handleSubmit = async (e) => {
    const downloadFile = (file) => {
      const url = window.URL.createObjectURL(new Blob([file]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "download.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
    };
  
    e.preventDefault();
    if (genSetNumber === 0) {
      setError("Please enter a valid Gen Set Id");
      return;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const data = await axios.post(
      URL + `/api/reports/product/${genSetNumber}`,
      {
        startDate,
        endDate,
      },
      config
    );
    downloadFile(data.data)
  };


  return (
    <>
      <Navbar />
      <br />
      <br />
      <br />
      <br />

      <div className="tw-mx-6 tw-font-nunito">
        <Link
          to="/admin/productlist"
          className="tw-flex tw-justify-center tw-items-center tw-w-12 tw-h-12 tw-ml-1 tw-mt-5 tw-rounded-full hover:tw-bg-gray-200"
        >
          <IoArrowBackOutline className="tw-text-blueGray-400 tw-text-4xl" />
        </Link>
        <FormContainer>
          <h3 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center tw-my-4">
            Download Genset Reports
          </h3>
          <Form
            onSubmit={handleSubmit}
            className="tw-flex tw-flex-col tw-w-full"
          >
            <Row>
              <Col xs={12} sm={4}>
                <Form.Group className="tw-py-2" controlId="role">
                  <Form.Label>Gen Set</Form.Label>
                  <Form.Control
                    as="select"
                    value={genSetNumber}
                    onChange={(e) => {
                      setGenSetNumber(e.target.value);
                    }}
                  >
                    <option disabled>Select</option>
                    {productList.products.map((e) => (
                      <option
                        key={`${e.gensetNumber}-index`}
                        value={e.gensetNumber}
                      >
                        {e.gensetNumber}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col xs={12} sm={4}>
                <Form.Group controlId="startDate" className="tw-my-1">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Start Date"
                    name="startDate"
                    value={startDate}
                    max={endDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
              <Col xs={12} sm={4}>
                <Form.Group controlId="endDate" className="tw-my-1">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="End Date"
                    min={startDate}
                    name="endDate"
                    value={endDate}
                    max={new Date().toISOString()?.split('T')[0]}
                    onChange={(e) => setEndDate(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Button
              type="submit"
              disabled={isLoading}
              className="tw-my-4 tw-mb-8 tw-px-28 tw-block tw-mx-auto tw-transition tw-duration-700 tw-ease-in-out tw-transform hover:-tw-translate-y-1 hover:tw-scale-110 myButton"
            >
              Download
            </Button>
          </Form>
        </FormContainer>
      </div>
    </>
  );
}

export default Reports;
